import { useState, useEffect } from 'react';
import { usePowerSync } from './PowerSyncContext';

/**
 * Custom hook to fetch all vehicleactivities from PowerSync
 * Uses real-time reactivity - component will re-render when data changes
 */
export const useVehicleActivities = (entityId,selectedDate) => {
  const { db, isConnected } = usePowerSync();
  const [vehicleactivities, setVehicleActivities] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!db || !isConnected || !selectedDate) {
      setIsLoading(false);
      return;
    }

    let mounted = true;

    /*const now = new Date();
    const startOfDay = new Date(now.setHours(0, 0, 0, 0)).toISOString();
    const endOfDay = new Date(now.setHours(23, 59, 59, 999)).toISOString();*/

    const dateStr = new Date(selectedDate);

    const start = new Date(dateStr);
    start.setUTCHours(0, 0, 0, 0);

    const end = new Date(dateStr);
    end.setUTCHours(23, 59, 59, 999);

    const startOfDay = start.toISOString();
    const endOfDay = end.toISOString();

    console.log('startOfDay', startOfDay);

    let query = `
      SELECT 
        va.*,
        vl.vehicle_no,
        vl.type,
        vl.model,
        vl.manufacturer,
        vl.category,
        vl.owner_name,
        vl.phone,
        vl.email,
        vl.total_petrol,
        vl.total_amount
      FROM vehicle_activities va
      LEFT JOIN vehicles vl ON va.vehicle_id = vl.id
      WHERE va.entity_id = ?
      AND va.created_at BETWEEN ? AND ?
      ORDER BY va.created_at DESC
    `;

   let whrCntVal = [entityId,startOfDay,endOfDay];

   console.log('whrCntVal', whrCntVal);

    const fetchVehicleActivities = async () => {
      try {
        setIsLoading(true);
        const result = await db.getAll(query, whrCntVal);

        if (mounted) {
          setVehicleActivities(result || []);
          setError(null);
        }
      } catch (err) {
        console.error('Error fetching vehicleactivities:', err);
        if (mounted) {
          setError(err?.message || String(err) || 'Failed to fetch vehicleactivities');
        }
      } finally {
        if (mounted) {
          setIsLoading(false);
        }
      }
    };

    fetchVehicleActivities();

    // Watch for changes in the vehicleactivities table
    const unsubscribe = db.watch(query, whrCntVal, {
      onResult: (result) => {
        if (mounted) {
          setVehicleActivities(result.rows?._array || []);
        }
      },
      onError: (err) => {
        console.error('Watch error:', err);
        if (mounted) {
          setError(err?.message || String(err) || 'Watch error');
        }
      }
    });

    return () => {
      mounted = false;
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [db, isConnected, selectedDate]);

  return {
    vehicleactivities,
    isLoading,
    error
  };
};
